// extracted by mini-css-extract-plugin
export default {"headerBar":"StaffMeetings_headerBar__WS4ik"};